<script setup>
import VueMultiselect from "vue-multiselect";
import { useTherapistStore } from "@/stores/therapist";
import { ref } from "vue";
import { WEEKDAYS } from "@/core/DateTime/Constants.js";

defineProps({
    modelValue: Boolean
});

const emit = defineEmits([ "update:modelValue" ]);

const therapistStore = useTherapistStore();
const selectedTherapists = ref([]);


function closeDialog() {
    emit("update:modelValue", false);
}
</script>
<template>
    <v-dialog
        class="w-75"
        height="500"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
    >
     <v-card>
       <v-card-title class="d-flex justify-space-between align-center">
         <div class="text-h6">
           Mass update Therapists Working Hours
         </div>

         <v-btn
             icon="mdi-close"
             variant="text"
             @click="closeDialog"
         ></v-btn>
       </v-card-title>
       <v-card-text>
         <div>
           <label class="block text-sm font-medium">Select Therapists</label>
           <VueMultiselect
               v-model="selectedTherapists"
               :options="therapistStore.therapists"
               :multiple="true"
               track-by="ROWID"
               value-prop="ROWID"
               label="full_name"
               :close-on-select="false"
               :clear-on-select="false"
               :preserve-search="true"
               placeholder="Select therapists"
           />
         </div>
         <div class="mt-1 bg-white rounded-lg shadow">
           <div class="p-4 border-b">
             <h3 class="font-semibold">Working Hours</h3>
           </div>
           <div class="p-4">
             <div class="grid grid-cols-7 gap-2">
               <!-- Day Headers -->
               <div v-for="day in WEEKDAYS"
                    :key="day"
                    class="text-center text-sm font-medium p-2 bg-gray-50 rounded">
                 {{ day }}
               </div>

               <!-- Working Hours -->
               <div v-for="(day, index) in WEEKDAYS"
                    :key="index"
                    class="text-center p-2 border rounded">
                   <div class="text-sm text-gray-400">Not Working</div>
               </div>
             </div>
           </div>
         </div>

       </v-card-text>
     </v-card>
    </v-dialog>
</template>

<style scoped>

</style>
